import { GET_USER_DETAILS_DATA, GET_STORETOKEN } from "../actions/actionTypes";
const initialState = {
    UserProfiledata:null,
    GetSSOToken:''
    };
    const homereducer = ( state = initialState, action = {}) => {
        switch (action.type) {
       case GET_USER_DETAILS_DATA:
         return {
         ...state,
         UserProfiledata: action.payload,
       }; 
       case GET_STORETOKEN:
        return {
        ...state,
        GetSSOToken: action.payload,
      };

    default:
      return state;
  }
};
export default homereducer;
